<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12">
        <v-flex xs12 md9 v-if="lAction === 'view'" mx-auto>
          <v-card-title class="title primary--text">
            Search Employee
          </v-card-title>
          <v-form ref="sForm" @submit.prevent="searchEmployee()">
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.emp_name"
                    label="Employee Name"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.emp_desig"
                    label="Designation"
                    hide-details
                    maxlength="35"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.vendor_emp_id"
                    label="Employee Id"
                    hide-details
                    maxlength="6"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.aadhar_no"
                    label="AADHAR No."
                    hide-details
                    maxlength="20"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.proj_name"
                    label="Assigned To Project"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    v-model="lSearch.emp_status"
                    label="Status"
                    :items="['On Job', 'In Bench', 'Resigned', 'Terminated']"
                    hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lSearch.emp_with_no_project"
                    label="Employee With NO Active Projects"
                    hide-details
                    class="shrink"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lSearch.emp_with_project"
                    label="Employee With Active Projects"
                    hide-details
                    class="shrink"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lSearch.emp_with_multiple_project"
                    label="Employee Deployed In Multiple Projects"
                    class="shrink"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lSearch.emp_from_usweb_app"
                    label="Employee Created by FM and Submitted"
                    hide-details
                    class="shrink"
                    ></v-checkbox>
                  </v-flex>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <i>Advanced search...</i>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <v-select
                            v-model="lSearch.verification_list"
                            label="Background Verification"
                            :items="['ID Verified', 'Address Verified', 'Police Verification']"
                            clearable
                            chips
                            multiple
                            hide-details
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-select
                            v-model="lSearch.doc_list"
                            label="Not Having Documents"
                            :items="empDocTypes"
                            item-value="emp_doc_type_id"
                            item-text="emp_doc_type"
                            clearable
                            chips
                            multiple
                            hide-details
                            ></v-select>
                          </v-flex>
                          <v-flex xs6>
                            <v-dialog ref="dlgFromDate"
                            persistent v-model="dlgFromDate"
                            max-width="290px"
                            :return-value.sync="lSearch.date_of_joining_from_dt"
                            >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                              slot="activator" label="Joining Date From"
                              v-model="lSearch.date_of_joining_from_dt"
                              append-icon="mdi-calendar-today"
                              v-on="on"
                              readonly clearable
                              hide-details
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="lSearch.date_of_joining_from_dt" scrollable
                            first-day-of-week="1"
                            >
                            <v-spacer></v-spacer>
                            <v-btn text @click="dlgFromDate = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.dlgFromDate.save(lSearch.date_of_joining_from_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs6>
                        <v-dialog ref="dlgToDate"
                        persistent v-model="dlgToDate"
                        max-width="290px"
                        :return-value.sync="lSearch.date_of_joining_to_dt"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="Joining Date Till"
                          v-model="lSearch.date_of_joining_to_dt"
                          append-icon="mdi-calendar-today"
                          readonly clearable
                          v-on="on"
                          hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="lSearch.date_of_joining_to_dt" scrollable
                        first-day-of-week="1"
                        >
                        <v-spacer></v-spacer>
                        <v-btn text @click="dlgToDate = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.dlgToDate.save(lSearch.date_of_joining_to_dt)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs6>
                    <v-dialog ref="dlgLastWorkFromDate"
                    persistent v-model="dlgLastWorkFromDate"
                    max-width="290px"
                    :return-value.sync="lSearch.last_working_date_from"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator" label="Last Working Date From"
                      v-model="lSearch.last_working_date_from"
                      append-icon="mdi-calendar-today"
                      v-on="on"
                      readonly clearable
                      hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="lSearch.last_working_date_from" scrollable
                    first-day-of-week="1"
                    >
                    <v-spacer></v-spacer>
                    <v-btn text @click="dlgLastWorkFromDate = false">Cancel</v-btn>
                    <v-btn text color="accent" @click="$refs.dlgLastWorkFromDate.save(lSearch.last_working_date_from)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6>
                <v-dialog ref="dlgLastWorkToDate"
                persistent v-model="dlgLastWorkToDate"
                max-width="290px"
                :return-value.sync="lSearch.last_working_date_till"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="Last Working Date Till"
                  v-model="lSearch.last_working_date_till"
                  append-icon="mdi-calendar-today"
                  readonly clearable
                  v-on="on"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lSearch.last_working_date_till" scrollable
                first-day-of-week="1"
                >
                <v-spacer></v-spacer>
                <v-btn text @click="dlgLastWorkToDate = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgLastWorkToDate.save(lSearch.last_working_date_till)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgLastUpdateDateFrom"
            persistent v-model="dlgLastUpdateDateFrom"
            max-width="290px"
            :return-value.sync="lSearch.last_Updated_date_from"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="Last Updated Date From"
              v-model="lSearch.last_Updated_date_from"
              append-icon="mdi-calendar-today"
              v-on="on"
              readonly clearable
              hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="lSearch.last_Updated_date_from" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn text @click="dlgLastUpdateDateFrom = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgLastUpdateDateFrom.save(lSearch.last_Updated_date_from)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-dialog ref="dlgLastUpdatedToDate"
        persistent v-model="dlgLastUpdatedToDate"
        max-width="290px"
        :return-value.sync="lSearch.last_Updated_date_till"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
          slot="activator" label="Last Updated Date Till"
          v-model="lSearch.last_Updated_date_till"
          append-icon="mdi-calendar-today"
          readonly clearable
          v-on="on"
          hide-details
          ></v-text-field>
        </template>
        <v-date-picker v-model="lSearch.last_Updated_date_till" scrollable
        first-day-of-week="1"
        >
        <v-spacer></v-spacer>
        <v-btn text @click="dlgLastUpdatedToDate = false">Cancel</v-btn>
        <v-btn text color="accent" @click="$refs.dlgLastUpdatedToDate.save(lSearch.last_Updated_date_till)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
</v-layout>
</v-expansion-panel-content>
</v-expansion-panel>
</v-expansion-panels>
</v-layout>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click="clear">Clear</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">search</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-flex>

<v-flex xs12 class="pt-2" v-if="lAction === 'view' && empList.length > 0" grid-list-md>
  <v-card-title class="pa-0">
    <v-flex xs12 class="title primary--text pa-1">
      <span>Search Result ({{empList.length}} Records)</span>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs6 class="pa-0">
        <v-switch
        v-model="showAllColumns"
        label="Show all columns"
        ></v-switch>
      </v-flex>
      <v-flex xs6>
        <v-download-as
        :headers="showAllColumns===true ? allColumnsHeader : emp"
        :items="empList"
        title="Employee List"
        :landscape="true"
        :fontsize="showAllColumns===true ? 6 : 9"
        :cellpadding="showAllColumns === true ? 0.25 : 1"
        ></v-download-as>
      </v-flex>
    </v-layout>
  </v-card-title>
  <v-card>
    <v-card-text class="pa-0 ma-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp? (showAllColumns===true ? allColumnsHeader : emp) : empSm"
      :items="empList"
      hide-default-footer
      disable-pagination
      :sort-by="['emp_name', 'vendor_emp_id']"
      multi-sort
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr @click="prepareEditEmp(props.item)">
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.emp_phone || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.emp_desig || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.act_proj_list || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.comp_proj_list || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.emp_email || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.emp_adr || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.city || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.pincode || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.emergency_contact || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.emergency_phone || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.blood_group || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.known_health_issue || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ handy.formatDate(props.item.date_of_birth) || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ handy.formatDate(props.item.date_of_joining) }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.years_exp || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.gender || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.aadhar_no || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.marital_status || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.official_number || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_id_verified ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_address_verified ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_police_verif_done  ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_pf_opted ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.pf_no || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.uan || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_esi_opted ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.esi_no || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_gmc_opted ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.gmc_no || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_gpa_opted ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.gpa_no || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.is_sub_vendor_emp ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.pan || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.bank_acc_no || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.bank_ifsc_code || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.bank_name || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.bank_branch_name || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.payroll_cat || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.date_of_relieved ? handy.formatDate(props.item.date_of_relieved) : '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.status_reason || '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ props.item.last_working_date ? handy.formatDate(props.item.last_working_date) : '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && showAllColumns===true">{{ handy.formatDate(props.item.last_updated_on) || '-' }}</td>
          <td>{{ props.item.emp_status }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>

<v-btn
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed color="accent" v-if="lAction === 'view'"
@click.native="prepareCreate">
<v-icon>mdi-plus</v-icon>
</v-btn>

<!-- upload btn -->
<v-btn small dark fab fixed v-if="lAction === 'view'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:65px;':'bottom:15px; left:290px;')"
@click.native="prepareUpload" color="accent">
<v-icon>mdi-upload</v-icon>
</v-btn>

<v-btn :style="'position:fixed; top:55px; right:10px;'" dark fab small fixed color="accent"
v-if="lAction === 'update'" @click.native="prepareEmpTimeline">
<v-icon>mdi-chart-line-variant</v-icon>
</v-btn>

<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 md9 mx-auto>
      <v-form ref="eForm" @submit.prevent="saveEmployee(lAction)">
        <v-card flat>
          <v-card-title class="title">
            {{ handy.startWithUpper(lAction) + ' Employee' }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 v-if="isDupEmp">
                <v-alert color="warning">
                  Employee with similar details found in records. Please choose override and save again if it is not duplicate. <br />
                  <v-data-table
                  :headers="dupEmp"
                  :items="dupEmpList"
                  hide-default-footer
                  disable-pagination
                  :mobile-breakpoint="0"
                  class="mt-2"
                  dark
                  >
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td>{{ props.item.emp_name }}</td>
                      <td>{{ props.item.vendor_emp_id }}</td>
                      <td>{{ props.item.aadhar_no || '-' }}</td>
                      <td>{{ props.item.act_proj_list || '-' }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <div text-center>
                  <v-switch
                  v-model="dupOverride"
                  label="Override"
                  hide-details
                  >
                </v-switch>
              </div>
            </v-alert>
          </v-flex>
          <v-flex xs12 sm6 class="pb-3">
            <v-radio-group
            v-model="empType"
            hide-details
            :mandatory="false"
            row
            >
            <v-radio label="Own Employee" value="oe"></v-radio>
            <v-radio label="Sub-vendor Employee" value="subvendor"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 sm6>
          <v-alert dense outlined :color="lAction === 'create' ? 'info' : 'warning'">
            <v-layout row wrap>
              <v-flex xs6>
                Employee Id {{lAction === 'create' ? 'will be' : 'is'}}
              </v-flex>
              <v-flex xs5>
                <strong v-if="!nextEmpEdited">{{lAction === 'create' ? lEmp.next_vendor_emp_id : lEmp.vendor_emp_id}}</strong>
                <v-text-field
                v-if="nextEmpEdited && lAction === 'create'"
                v-model="lEmp.next_vendor_emp_id"
                :rules="[rules.required]"
                hide-details
                maxlength="10"
                outlined
                dense
                ></v-text-field>
                <v-text-field
                v-if="nextEmpEdited && lAction === 'update'"
                v-model="lEmp.vendor_emp_id"
                :rules="[rules.required]"
                hide-details
                maxlength="10"
                outlined
                dense
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn small icon @click="nextEmpEdited=!nextEmpEdited"><v-icon small>mdi-pencil</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </v-alert>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.emp_name"
          label="Employee Name [As Per Aadhar]"
          :rules="[rules.required]"
          hide-details
          maxlength="50"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-select
          v-model="lEmp.sub_vendor_id"
          label="Sub Vendor"
          :items="subVendorList"
          item-text="vendor_name"
          item-value="sub_vendor_id"
          :disabled="empType !== 'subvendor'"
          :rules="empType === 'subvendor' ? [rules.required] : []"
          hide-details
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-select
          v-model="lEmp.emp_desig_pair"
          label="Designation"
          :items="empDesig"
          item-text="emp_desig"
          item-value="emp_desig_id"
          :rules="[rules.required]"
          hide-details
          return-object
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-select
          v-model="lEmp.gender"
          label="Gender"
          :items="['Male', 'Female']"
          :rules="[rules.required]"
          hide-details
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-dialog ref="dlgjoinDt"
          persistent v-model="dlgjoinDt"
          max-width="290px"
          :return-value.sync="lEmp.date_of_joining"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
            slot="activator" label="Date Of Joining"
            v-model="lEmp.date_of_joining" append-icon="mdi-calendar-today"
            readonly v-on="on"
            hide-details
            clearable
            :rules="[rules.required]"
            ></v-text-field>
          </template>
          <v-date-picker v-model="lEmp.date_of_joining"
          >
          <div class="flex-grow-1"></div>
          <v-btn text @click="dlgjoinDt = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.dlgjoinDt.save(lEmp.date_of_joining)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs6>
      <!-- Earlier it was used for years of Experience. Usedto show age now. -->
      <v-text-field
      v-model="lEmp.years_exp"
      label="Age"
      hide-details
      readonly
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-dialog ref="dlgDt"
      persistent v-model="dlgDt"
      max-width="290px"
      :return-value.sync="lEmp.date_of_birth"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
        slot="activator" label="Date Of Birth [As Per Aadhar]"
        v-model="lEmp.date_of_birth" append-icon="mdi-calendar-today"
        readonly
        v-on="on"
        hide-details
        :rules="[rules.required]"
        clearable
        ></v-text-field>
      </template>
      <v-date-picker v-model="lEmp.date_of_birth"
      @change="calculateAge(lEmp.date_of_birth)"
      >
      <div class="flex-grow-1"></div>
      <v-btn text @click="dlgDt = false">Cancel</v-btn>
      <v-btn text color="accent" @click="$refs.dlgDt.save(lEmp.date_of_birth)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</v-flex>
<v-flex xs6>
  <v-text-field
  v-model="lEmp.aadhar_no"
  label="AADHAR No."
  hide-details
  maxlength="20"
  :rules="[rules.required]"
  required
  ></v-text-field>
</v-flex>
<v-flex xs6>
  <v-select
  v-model="lEmp.marital_status"
  label="Marital Status"
  :items="['Single', 'Married', 'Widowed', 'Separated', 'Divorced']"
  :rules="[rules.required]"
  required
  hide-details
  ></v-select>
</v-flex>
<v-flex xs6>
  <v-text-field
  v-model="lEmp.official_number"
  label="Official Number"
  hide-details
  type="number"
  ></v-text-field>
</v-flex>
<v-flex xs6>
  <v-select
  v-model="lEmp.emp_status"
  label="Status"
  :items="['On Job', 'In Bench', 'Resigned', 'Terminated']"
  hide-details
  ></v-select>
</v-flex>
<v-flex xs6>
  <v-dialog ref="dlglastworkingDt"
  persistent v-model="dlglastworkingDt"
  max-width="290px"
  :return-value.sync="lEmp.last_working_date"
  >
  <template v-slot:activator="{ on }">
    <v-text-field
    slot="activator" label="Relieving Date"
    v-model="lEmp.last_working_date" append-icon="mdi-calendar-today"
    readonly v-on="on"
    hide-details
    clearable
    :disabled="lEmp.emp_status === 'On Job' || lEmp.emp_status === 'In Bench'"
    :rules="(lEmp.emp_status === 'On Job' || lEmp.emp_status === 'In Bench') ? [] : [rules.required]"
    ></v-text-field>
  </template>
  <v-date-picker v-model="lEmp.last_working_date"
  >
  <div class="flex-grow-1"></div>
  <v-btn text @click="dlglastworkingDt = false">Cancel</v-btn>
  <v-btn text color="accent" @click="$refs.dlglastworkingDt.save(lEmp.last_working_date)">OK</v-btn>
</v-date-picker>
</v-dialog>
</v-flex>
<v-flex xs12 class="pt-0">
  <v-text-field
  v-model="lEmp.status_reason"
  label="Relieving Reason"
  :disabled="lEmp.emp_status === 'On Job' || lEmp.emp_status === 'In Bench'"
  hide-details
  maxlength="100"
  :rules="(lEmp.emp_status === 'On Job' || lEmp.emp_status === 'In Bench') ? [] : [rules.required]"
  ></v-text-field>
</v-flex>
<v-flex xs12 class="pt-3">
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-card-title class="pa-0">
          Background Verification
        </v-card-title>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-checkbox
              v-model="lEmp.is_bg_verify_require"
              label="Background Verification required"
              hide-details
              class="shrink"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 v-if="lEmp.is_bg_verify_require">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-checkbox
                  v-model="lEmp.is_id_verified"
                  label="ID Verified"
                  hide-details
                  class="shrink"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="dlgIdVerifyDt"
                  persistent v-model="dlgIdVerifyDt"
                  max-width="290px"
                  :return-value.sync="lEmp.id_verified_date"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="ID Verified Date"
                    v-model="lEmp.id_verified_date" append-icon="mdi-calendar-today"
                    readonly v-on="on"
                    hide-details
                    :disabled="!lEmp.is_id_verified"
                    clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lEmp.id_verified_date"
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn text @click="dlgIdVerifyDt = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgIdVerifyDt.save(lEmp.id_verified_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-checkbox
              v-model="lEmp.is_address_verified"
              label="Address Verified"
              hide-details
              class="shrink"
              ></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-dialog ref="dlgAddressVerifyDt"
              persistent v-model="dlgAddressVerifyDt"
              max-width="290px"
              :return-value.sync="lEmp.address_verified_date"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                slot="activator" label="Address Verified Date"
                v-model="lEmp.address_verified_date" append-icon="mdi-calendar-today"
                readonly v-on="on"
                hide-details
                clearable
                :disabled="!lEmp.is_address_verified"
                ></v-text-field>
              </template>
              <v-date-picker v-model="lEmp.address_verified_date"
              >
              <div class="flex-grow-1"></div>
              <v-btn text @click="dlgAddressVerifyDt = false">Cancel</v-btn>
              <v-btn text color="accent" @click="$refs.dlgAddressVerifyDt.save(lEmp.address_verified_date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs6>
          <v-checkbox
          v-model="lEmp.is_police_verif_done"
          label="Police Verification"
          hide-details
          class="shrink"
          ></v-checkbox>
        </v-flex>
        <v-flex xs6>
          <v-dialog ref="dlgPoliceVerifyDt"
          persistent v-model="dlgPoliceVerifyDt"
          max-width="290px"
          :return-value.sync="lEmp.police_verif_date"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
            slot="activator" label="Police Verified Date"
            v-model="lEmp.police_verif_date" append-icon="mdi-calendar-today"
            readonly v-on="on"
            :disabled="!lEmp.is_police_verif_done"
            hide-details
            clearable
            ></v-text-field>
          </template>
          <v-date-picker v-model="lEmp.police_verif_date"
          >
          <div class="flex-grow-1"></div>
          <v-btn text @click="dlgPoliceVerifyDt = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.dlgPoliceVerifyDt.save(lEmp.police_verif_date)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
  </v-layout>
</v-flex>
</v-layout>
</v-card-text>
</v-expansion-panel-content>
</v-expansion-panel>
<v-expansion-panel>
  <v-expansion-panel-header>
    <v-card-title class="pa-0">
      Personal Information
    </v-card-title>
  </v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex xs12 class="pt-0">
          <v-text-field
          v-model="lEmp.emp_adr"
          label="Address"
          hide-details
          maxlength="100"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.city"
          label="City"
          hide-details
          maxlength="25"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.pin_code"
          label="PIN"
          :rules="[rules.required]"
          hide-details
          maxlength="10"
          type="number"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.emp_phone"
          label="Phone"
          hide-details
          maxlength="15"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.emp_email"
          label="Email"
          hide-details
          maxlength="50"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <span class="primary--text">Emergency Contact</span>
        </v-flex>
        <v-flex xs6 class="pt-0">
          <v-text-field
          v-model="lEmp.emergency_phone"
          label="Phone"
          hide-details
          maxlength="15"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 class="pt-0">
          <v-text-field
          v-model="lEmp.emergency_contact"
          label="Contact Person"
          hide-details
          maxlength="50"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.blood_group"
          label="Blood Group"
          hide-details
          maxlength="5"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.known_health_issue"
          label="Health Issue Known"
          hide-details
          maxlength="50"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-expansion-panel-content>
</v-expansion-panel>
<v-expansion-panel>
  <v-expansion-panel-header>
    <v-card-title class="pa-0">
      Payroll Information
    </v-card-title>
  </v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex xs3>
          <v-select
          v-model="lEmp.payroll_cat"
          label="Payroll Category"
          outlined
          dense
          style="font-size: 12px"
          :items="['REGULAR', 'DR', 'TDS', 'PT']"
          hide-details
          ></v-select>
        </v-flex>
        <v-flex xs3 style="margin-top: -10px;">
          <v-checkbox
          v-model="lEmp.is_pf_opted"
          label="Is PF Opted?"
          hide-details
          style="font-size: 12px"
          :disabled="lEmp.is_professional_fee_opted ? true : false"
          class="shrink my-label-text-size"
          ></v-checkbox>
        </v-flex>
        <v-flex xs3 style="margin-top: -10px;">
          <v-text-field
          v-model="lEmp.pf_no"
          label="PF Number"
          hide-details
          maxlength="40"
          style="font-size: 12px"
          :disabled="!lEmp.is_pf_opted ? true : false"
          ></v-text-field>
        </v-flex>
        <v-flex xs3 style="margin-top: -10px;">
          <v-text-field
          v-model="lEmp.uan"
          label="UAN Number"
          hide-details
          maxlength="40"
          style="font-size: 12px"
          :disabled="!lEmp.is_pf_opted ? true : false"
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-checkbox
          v-model="lEmp.is_pan_available"
          label="Is PAN Opted?"
          hide-details
          style="font-size: 12px"
          class="shrink my-label-text-size"
          ></v-checkbox>
        </v-flex>
        <v-flex xs3 class="pt-0">
          <v-text-field
          v-model="lEmp.pan"
          label="PAN Number"
          hide-details
          maxlength="20"
          style="font-size: 12px"
          :disabled="!lEmp.is_pan_available"
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-checkbox
          v-model="lEmp.is_esi_opted"
          label="Is ESI Opted?"
          hide-details
          :disabled="lEmp.is_professional_fee_opted ? true : false"
          style="font-size: 12px"
          class="shrink my-label-text-size"
          ></v-checkbox>
        </v-flex>
        <v-flex xs3>
          <v-text-field
          v-model="lEmp.esi_no"
          label="ESI Number"
          hide-details
          maxlength="40"
          style="font-size: 12px"
          :disabled="!lEmp.is_esi_opted ? true : false"
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-checkbox
          v-model="lEmp.is_gmc_opted"
          label="Is GMC Opted?"
          hide-details
          style="font-size: 12px"
          class="shrink my-label-text-size"
          ></v-checkbox>
        </v-flex>
        <v-flex xs3>
          <v-text-field
          v-model="lEmp.gmc_no"
          label="GMC Number"
          hide-details
          maxlength="40"
          style="font-size: 12px"
          :disabled="!lEmp.is_gmc_opted ? true : false"
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-checkbox
          v-model="lEmp.is_gpa_opted"
          label="Is GPA Opted?"
          hide-details
          style="font-size: 12px"
          class="shrink my-label-text-size"
          ></v-checkbox>
        </v-flex>
        <v-flex xs3>
          <v-text-field
          v-model="lEmp.gpa_no"
          label="GPA Number"
          hide-details
          maxlength="40"
          style="font-size: 12px"
          :disabled="!lEmp.is_gpa_opted ? true : false"
          ></v-text-field>
        </v-flex>
        <v-flex xs3 class="pl-2">
          <v-checkbox
          v-model="lEmp.is_professional_fee_opted"
          label="Is Professional Fee Opted?"
          hide-details
          :disabled="(lEmp.is_pf_opted || lEmp.is_esi_opted) ? true : false"
          style="font-size: 12px"
          class="shrink my-label-text-size"
          ></v-checkbox>
        </v-flex>
        <v-flex xs3 class="pt-0">
          <v-text-field
          v-model="lEmp.professional_fee"
          label="Professional Fee"
          hide-details
          maxlength="20"
          style="font-size: 12px"
          :disabled="!lEmp.is_professional_fee_opted ? true : false"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <span class="primary--text">Bank Account Details</span>
        </v-flex>
        <v-flex xs6 class="pt-0">
          <v-text-field
          v-model="lEmp.bank_acc_no"
          label="Bank Account Number"
          hide-details
          maxlength="25"
          style="font-size: 12px"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 class="pt-0">
          <v-text-field
          v-model="lEmp.bank_ifsc_code"
          label="Bank IFSC Code"
          hide-details
          maxlength="15"
          style="font-size: 12px"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.bank_name"
          label="Bank Name"
          hide-details
          maxlength="100"
          style="font-size: 12px"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lEmp.bank_branch_name"
          label="Branch Name"
          hide-details
          maxlength="100"
          style="font-size: 12px"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-expansion-panel-content>
</v-expansion-panel>
<v-expansion-panel>
  <v-expansion-panel-header>
    <v-card-title class="pa-0">
      Documents
    </v-card-title>
  </v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-card-text class="pa-0">
      <div class="text-right pb-2">
        <v-btn small @click="showDocTypeList()">Manage Document Types</v-btn>
      </div>
      <v-data-table
      :headers="empHeader"
      :items="lEmpDetails"
      class="elevation-1"
      hide-default-footer
      :mobile-breakpoint="0"
      disable-sort
      disable-pagination>
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.emp_doc_type }}</td>
          <td :class="props.item.files.length > 0 ? 'pt-2' : ''"><span v-for="(file, i) in props.item.files" :key="i">
            <span v-if="file.is_selected">
              <v-chip small close class="mb-2" @click:close="file.is_selected = false">
                {{file.file_name}}
                <a :href="handy.loadImg(file.file_url, true)" download style="text-decoration: none;">
                  <v-btn small icon class="mr-0 grey lighten-1 grey--text text--lighten-4 ml-2">
                    <v-icon small>mdi-download</v-icon>
                  </v-btn>
                </a>
              </v-chip><br />
            </span>
          </span></td>
          <td class="pl-2 pr-0">
            <input style="display:none" type="file" ref="fileInput"
            accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg"
            multiple @change="loadFilesFromFileBrowser()"/>
            <v-btn icon @click="pickFile(props.item.emp_doc_type_id)"><v-icon>mdi-upload</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-expansion-panel-content>
</v-expansion-panel>

<v-expansion-panel>
  <v-expansion-panel-header>
    <v-card-title class="pa-0">
      Family Details
    </v-card-title>
  </v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-card-text class="pa-0">
      <div class="text-right pb-2">
        <v-btn :disabled="!lEmp.emp_id" small @click="addEmpFamilyDet(lEmp.emp_id)">Add Family Details</v-btn>
      </div>
      <v-data-table
      :headers="empFamilyHeader"
      :items="EmpFamilyDetailsList"
      class="elevation-1"
      hide-default-footer
      :mobile-breakpoint="0"
      disable-sort
      :height="EmpFamilyDetailsList.length > 4 ? '310px' : ''"
      disable-pagination>
      <template slot="item" slot-scope="props">
        <tr @click="prepareUpdateFamilyDet(props.item)">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.family_name }}</td>
          <td>{{ props.item.relation_with_emp }}</td>
          <td>{{ handy.formatDate(props.item.dob) }}</td>
          <td>{{ props.item.residing_with_him === 1 ? 'Yes' : 'No' }}</td>
          <td>{{ props.item.contact_number }}</td>
          <td>{{ props.item.nominee === 1 ? 'Yes' : 'No' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-expansion-panel-content>
</v-expansion-panel>
</v-expansion-panels>
</v-flex>
</v-layout>
</v-card-text>
<v-card-actions>
  <v-btn v-if="lAction === 'update'" @click="deleteEmp(lEmp)">delete</v-btn>
  <v-spacer></v-spacer>
  <v-btn @click.stop="cancelChanges()">Cancel</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
  <v-btn v-if="lAction === 'update' && lEmp.emp_add_usweb_status === 'Submitted'" @click="approveUsWebEmp()">approve</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>

<v-dialog v-model="showDocType" width="500" persistent scrollable>
  <v-flex>
    <v-card flat>
      <v-card-title class="pa-2 title primary--text grey lighten-4">
        Document Types
        <v-spacer></v-spacer>
        <v-btn icon @click="showDocType = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <div class="text-right pb-2">
          <v-btn color="accent" @click="prepareCreateDocType()">Add New</v-btn>
        </div>
        <v-flex xs12>
          <v-data-table
          :headers="docTypeHeader"
          :items="lEmpDetails"
          class="elevation-1"
          hide-default-footer
          :mobile-breakpoint="0"
          disable-sort
          disable-pagination>
          <template slot="item" slot-scope="props">
            <tr @click="prepareUpdateDocType(props.item)">
              <td>{{ props.item.emp_doc_type }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<v-dialog v-model="showInsertUpdateDocType" width="300" persistent scrollable>
  <v-flex>
    <v-form ref="lForm" @submit.prevent="saveDocTypeChange('doctype')">
      <v-card flat>
        <v-card-title>
          {{ handy.startWithUpper(lDAction) }} Document Type
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-text-field
            v-model="lDocType.emp_doc_type"
            label="Doc Type"
            :rules="[rules.required]"
            hide-details
            maxlength="25"
            ></v-text-field>
          </v-flex>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn v-if="lDocType.emp_doc_type_id" @click="saveDocTypeChange('delete-doctype')">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.stop="showInsertUpdateDocType = false">Cancel</v-btn>
          <v-btn type="submit" color="accent">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-dialog>

<!-- Employee Family Details -->
<v-dialog v-model="showEmpFamilyDetList" scrollable max-width="500px">
  <v-flex xs12>
    <v-form ref="cForm" @submit.prevent="saveEmpFamilydetail(lEmpFamilyDetails.action)">
      <v-card flat>
        <v-card-title class="pa-2 title primary--text grey lighten-4">
          Family Details
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="pt-2">
            <v-layout row wrap>
              <v-flex xs6 class="px-2">
                <v-text-field
                v-model="lEmpFamilyDetails.family_name"
                label="Name of the Family Member"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="px-2">
                <v-text-field
                v-model="lEmpFamilyDetails.relation_with_emp"
                label="Relationship with Employee"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6 class="px-2">
                <v-dialog ref="dlgFamilyBDt"
                persistent v-model="dlgFamilyBDt"
                max-width="290px"
                :return-value.sync="lEmpFamilyDetails.dob"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="Date Of Birth"
                  v-model="lEmpFamilyDetails.dob" append-icon="mdi-calendar-today"
                  readonly
                  v-on="on"
                  hide-details
                  clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lEmpFamilyDetails.dob"
                >
                <div class="flex-grow-1"></div>
                <v-btn text @click="dlgFamilyBDt = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgFamilyBDt.save(lEmpFamilyDetails.dob)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6 class="px-2">
            <v-checkbox label="Residing with Him/Her?" hide-details
            v-model="lEmpFamilyDetails.residing_with_him"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs6 class="px-2">
            <v-text-field
            v-model="lEmpFamilyDetails.contact_number"
            label="Contact Number"
            hide-details
            type="number"
            maxlength="15"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="px-2">
            <v-checkbox label="Is Nominee?" hide-details
            v-model="lEmpFamilyDetails.nominee"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-btn v-if="lEmpFamilyDetails.action === 'Update'" @click="saveEmpFamilydetail('delete')">delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="showEmpFamilyDetList = false">close</v-btn>
      <v-btn type="submit" color="accent">save</v-btn>
    </v-card-actions>
  </v-card>
</v-form>
</v-flex>
</v-dialog>

<!-- upload files -->
<v-container v-if="lAction === 'upload'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Employee List
        </v-card-title>
        <div class="mt-3 text-center primary--text title font-italic">
          In just 4 steps
        </div>
        <v-card-text class="subheading">
          <v-layout row wrap>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 1</v-chip>
              <span>Download template</span>
              <span style="float:right;">
                <form method="get" action="/files/Smartility_Backbone_Employee_Bulk_Upload_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>mdi-download</v-icon></v-btn>
                </form>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 2</v-chip>
              <span>Fill-in details as guided in template</span>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 3</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 4</v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>mdi-upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-center primary--text title font-italic">
              Smartility BackBone takes care of rest
            </div>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 4</v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 5</v-chip>
            <span>Create Asset List</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0 pr-4">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- 6. validate and upload -->
<v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pb-0">
          Bulk Upload
        </v-card-title>
        <v-card-text class="text-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12 md9 mx-auto>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Tasks uploaded successfully<v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Tasks upload failed<v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Tasks upload partially failed<v-icon class="warning--text">mdi-close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recsLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn class="mr-4" small @click.native="lAction='upload'">Cancel</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadEmployee" :disabled="beingSaved">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="mt-2 pa-2">
        <v-data-table
        :headers="loadHeadSm"
        :items="recsLoaded"
        hide-default-footer
        :mobile-breakpoint="0"
        class="elevation-3 text-left"
        >
        <template slot="item" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td class="pa-2">{{ props.item.vendor_emp_id }}</td>
            <td class="pa-2">{{ props.item.emp_name }}</td>
            <td class="pa-2">{{ props.item.pf_no }}</td>
            <td class="pa-2">{{ props.item.uan }}</td>
            <td class="pa-2">{{ props.item.esi_no }}</td>
            <td class="pa-2">{{ props.item.gmc_no }}</td>
            <td class="pa-2">{{ props.item.gpa_no }}</td>
            <td class="pa-2">{{ props.item.bank_acc_no }}</td>
            <td class="pa-2">{{ props.item.bank_ifsc_code }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- 3. show Timeline for particular task_id -->
<v-dialog v-model="showTimeline" scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-1 title primary--text">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon class="primary--text" @click.stop="showTimeline = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text style="background-color: #ffe8d9" class="pl-0 pr-4 py-3">
      <v-timeline dense class="pt-0">
        <v-timeline-item :class="n === lEmpTimeline.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lEmpTimeline"
        :key="n"
        small
        :id="'timeline_' + n"
        >
        <v-card class="primary--text">
          <v-card-text class="pb-0 black--text">
            <div v-if="timeline.notes !== ''">
              <div v-for="(note, i) in timeline.timeLineNote" :key="i">
                <span v-if="note">{{ i+1 + '. ' + note }}</span>
              </div>
            </div>
            <div v-else class="pb-1">
              {{ timeline.notes }}
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="caption pa-2">
            Updated by:&nbsp; <span style="font-weight: bold;">{{ timeline.action_by + ' On ' + handy.formatDate(timeline.action_dt) + ' ' + handy.getTime12Hrs(timeline.action_dt) }}</span>
          </v-card-actions>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </v-card-text>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import VDownloadAs from './VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      emp: [
        { text: 'Name', value: 'emp_name' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Phone', value: 'emp_phone' },
        { text: 'Designation', value: 'emp_desig' },
        { text: 'Active Project', value: 'act_proj_list', width: '200px' },
        { text: 'Completed Project', value: 'comp_proj_list', width: '200px' },
        { text: 'Status', value: 'emp_status' }
      ],
      allColumnsHeader: [
        { text: 'Name', value: 'emp_name', width: '101px' },
        { text: 'Employee Id', value: 'vendor_emp_id', width: '140px' },
        { text: 'Phone', value: 'emp_phone', sortable: false },
        { text: 'Designation', value: 'emp_desig', width: '120px', sortable: false },
        { text: 'Active Project', value: 'act_proj_list', sortable: false },
        { text: 'Completed Project', value: 'comp_proj_list', sortable: false },
        { text: 'Email', value: 'emp_email', sortable: false },
        { text: 'Address', value: 'emp_adr', sortable: false },
        { text: 'City', value: 'city', sortable: false },
        { text: 'PIN', value: 'pin_code', sortable: false },
        { text: 'Emergency Contact', value: 'emergency_contact', sortable: false },
        { text: 'Emergency Phone', value: 'emergency_phone', sortable: false },
        { text: 'Blood Group', value: 'blood_group', sortable: false },
        { text: 'Known Health Issue', value: 'known_health_issue', width: '110px', sortable: false },
        { text: 'Date Of Birth', value: 'date_of_birth', sortable: false, width: '100px' },
        { text: 'Date Of Joining', value: 'date_of_joining', sortable: false, width: '100px' },
        { text: 'Experience', value: 'years_exp', sortable: false },
        { text: 'Gender', value: 'gender', width: '150px', sortable: false },
        { text: 'AADHAAR Number', value: 'aadhar_no', sortable: false },
        { text: 'Marital Status', value: 'marital_status', sortable: false },
        { text: 'Officical Number', value: 'official_number', sortable: false },
        { text: 'ID Verified?', value: 'is_id_verified', sortable: false },
        { text: 'Address Verifiled?', value: 'is_address_verified', sortable: false },
        { text: 'Police Verified?', value: 'is_police_verif_done', sortable: false },
        { text: 'Is PF Opted?', value: 'is_pf_opted', sortable: false  },
        { text: 'PF No', value: 'pf_no', width: '150px', sortable: false },
        { text: 'UAN No', value: 'uan', width: '150px', sortable: false },
        { text: 'Is ESI Opted?', value: 'is_esi_opted', sortable: false },
        { text: 'ESI No', value: 'esi_no', sortable: false },
        { text: 'Is GMC Opted?', value: 'is_gmc_opted', sortable: false },
        { text: 'GMC No', value: 'gmc_no', sortable: false },
        { text: 'Is GPA Opted?', value: 'is_gpa_opted', sortable: false },
        { text: 'GPA No', value: 'gpa_no', sortable: false },
        { text: 'Sub Vendor Emp?', value: 'is_sub_vendor_emp', sortable: false, width: '100px' },
        { text: 'PAN No', value: 'pan', sortable: false },
        { text: 'Bank Account No', value: 'bank_acc_no_for_exp', sortable: false },
        { text: 'Bank IFSC Code', value: 'bank_ifsc_code', sortable: false },
        { text: 'Bank Name', value: 'bank_name', sortable: false },
        { text: 'Bank Branch Name', value: 'bank_branch_name', sortable: false },
        { text: 'Payroll Category', value: 'payrol_cat', sortable: false },
        { text: 'Relieving Date', value: 'date_of_relieved', sortable: false },
        { text: 'Relieving Reason', value: 'status_reason', sortable: false },
        { text: 'Last Working Date', value: 'last_working_date', sortable: false, width: '130px' },
        { text: 'Last Updated On', value: 'last_updated_on', sortable: false, width: '100px' },
        { text: 'Status', value: 'emp_status', sortable: false }
      ],
      empSm: [
        { text: 'Name', value: 'emp_name' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Status', value: 'emp_status' }
      ],
      dupEmp: [
        { text: 'Name', value: 'emp_name' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'AADHAR No.', value: 'aadhar_no' },
        { text: 'Active Project', value: 'act_proj_list' }
      ],
      empList: [],
      lEmp: {},
      previousData: {},
      lEmpTimeline: {},
      showTimeline: false,
      nextEmpEdited: false,
      dupEmpList: [],
      isDupEmp: false,
      dupOverride: false,
      empDesig: [],
      dlgDt: false,
      dlgjoinDt: false,
      dlgReliveDt: false,
      dlglastworkingDt: false,
      dlgLastUpdateDateFrom: false,
      dlgLastUpdatedToDate: false,
      subVendorList: [],
      empType: 'oe',
      lSearch: {},
      // emp Documents
      empHeader: [
        { text: 'Document', value: 'emp_doc_type' },
        { text: 'File', value: 'file_url' },
        { text: '', value: '', width: '40px' }
      ],
      empDocTypeId: null,
      lEmpDetails: [],
      // insert/update/delete doc type
      showDocType: false,
      lDocType: {},
      showInsertUpdateDocType: false,
      lDAction: '',
      docTypeHeader: [
        { text: 'Document', value: 'emp_doc_type' }
      ],
      empDocTypes: [],
      dlgFromDate: false,
      dlgToDate: false,
      dlgLastWorkFromDate: false,
      dlgLastWorkToDate: false,
      showAllColumns: false,
      dlgIdVerifyDt: false,
      dlgAddressVerifyDt: false,
      dlgPoliceVerifyDt: false,
      // family details
      empFamilyHeader: [
        { text: 'Sr No.', value: '' },
        { text: 'Name of the Family Members', value: 'family_name', width: '126px' },
        { text: 'Relationship with Employee', value: 'relation_with_emp', width: '126px' },
        { text: 'Date of Birth', value: 'dob', width: '120px' },
        { text: 'Residing with Him/Her', value: 'residing_with_him', width: '126px' },
        { text: 'Contact Number', value: 'contact_number' },
        { text: 'Nominee', value: 'nominee' }
      ],
      lEmpFamilyDetails: [],
      EmpFamilyDetailsList: [],
      showEmpFamilyDetList: false,
      dlgFamilyBDt: false,
      // Employee upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      reqHeaders: ['Emp ID', 'Emp Name', 'PF Number', 'UAN No.', 'ESI No.', 'GMC No.', 'GPA No.', 'Bank Acc No.', 'Bank IFSC Code'],
      colNames: [
        {col_name: 'vendor_emp_id', is_required: true},
        {col_name: 'emp_name', is_required: true},
        {col_name: 'pf_no', is_required: false},
        {col_name: 'uan', is_required: false},
        {col_name: 'esi_no', is_required: false},
        {col_name: 'gmc_no', is_required: false},
        {col_name: 'gpa_no', is_required: false},
        {col_name: 'bank_acc_no', is_required: false},
        {col_name: 'bank_ifsc_code', is_required: false}
      ],
      loadHeadSm: [
        { text: 'Emp ID', value: 'vendor_emp_id' },
        { text: 'Emp Name', value: 'emp_name' },
        { text: 'PF Number', value: 'pf_no' },
        { text: 'UAN No.', value: 'uan' },
        { text: 'ESI No.', value: 'esi_no' },
        { text: 'GMC No.', value: 'gmc_no' },
        { text: 'GPA No.', value: 'gpa_no' },
        { text: 'Bank Acc No.', value: 'bank_acc_no' },
        { text: 'Bank IFSC Code', value: 'bank_ifsc_code' }
      ]
    }
  },
  mounted () {
    this.lAction = 'view'
    // load available doc types
    this.loadMasterDocTypes()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    searchEmployee () {
      if (!this.lSearch.emp_name && !this.lSearch.vendor_emp_id && !this.lSearch.aadhar_no && !this.lSearch.emp_desig && !this.lSearch.proj_name && !this.lSearch.emp_status && !this.lSearch.emp_with_project && !this.lSearch.emp_with_no_project && !this.lSearch.emp_from_usweb_app && (!this.lSearch.verification_list || !this.lSearch.verification_list.length) && (!this.lSearch.doc_list || !this.lSearch.doc_list.length) && !this.lSearch.emp_with_multiple_project && !this.lSearch.date_of_joining_from_dt && !this.lSearch.date_of_joining_to_dt && !this.lSearch.last_working_date_from && !this.lSearch.last_working_date_till && !this.lSearch.last_Updated_date_from && !this.lSearch.last_Updated_date_till) {
        this.msg('Please enter any search criteria', 0)
        return
      }
      else if (this.lSearch.date_of_joining_from_dt && !this.lSearch.date_of_joining_to_dt) {
        this.lSearch.date_of_joining_to_dt = this.lSearch.date_of_joining_from_dt
      }
      else if (this.lSearch.last_working_date_from && !this.lSearch.last_working_date_till) {
        this.lSearch.last_working_date_till = this.lSearch.last_working_date_from
      }
      else if (this.lSearch.last_Updated_date_from && !this.lSearch.last_Updated_date_till) {
        this.lSearch.last_Updated_date_till = this.lSearch.last_Updated_date_from
      }
      var qry = {
        params: {
        }
      }
      qry.params = this.lSearch
      qry.params.vendor_id = config.VENDOR_ID
      this.beingSaved = true
      this.axios.get(config.API_URL + '/searchEmployee/', qry)
      .then(response => {
        this.empList = response.data
        if (!this.empList.length) {
          this.msg('No records found for given search criteria', 0)
        }
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.empList = []
        this.beingSaved = false
      })
    },
    getEmptyEmp () {
      var emptyEmp = {
        vendor_id: config.VENDOR_ID,
        empType: 'oe',
        sub_vendor_id: '',
        emp_name: '',
        emp_desig_pair: '',
        years_exp: null,
        city: '',
        date_of_birth: '',
        date_of_joining: '',
        gender: '',
        emp_status: 'On Job',
        emp_phone: 0,
        last_working_date: '',
        status_reason: '',
        is_pf_opted: 0,
        pf_no: '',
        is_esi_opted: 0,
        esi_no: '',
        is_gmc_opted: 0,
        gmc_no: '',
        is_gpa_opted: 0,
        gpa_no: '',
        payroll_cat: 'REGULAR',
        is_id_verified: false,
        is_address_verified: false,
        is_police_verif_done: false,
        is_bg_verify_require: false,
        id_verified_date: null,
        address_verified_date: null,
        police_verif_date: null,
        is_pan_available: 0,
        uan: '',
        official_number: '',
        marital_status: '',
        is_professional_fee_opted: false,
        professional_fee: ''
      }
      return emptyEmp
    },
    prepareCreate () {
      this.lEmp = this.getEmptyEmp()
      this.dupOverride = false
      this.isDupEmp = false
      // next emp id
      this.loadNextEmpId()
      this.lAction = 'create'
      this.loadDesignation()
      this.loadSubVendor()
      this.loadDocType()
    },
    loadNextEmpId () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getNextEmpId/', qry)
      .then(response => {
        this.lEmp.next_vendor_emp_id = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadDesignation () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmpDesigByVendorId/', qry)
      .then(response => {
        this.empDesig = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadSubVendor () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSubVendorByVendorId/', qry)
      .then(response => {
        this.subVendorList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadDocType (empId = null) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          emp_id: empId
        }
      }
      this.lEmpDetails = []
      this.axios.get(config.API_URL + '/getDocumentTypeBasedonVendorId/', qry)
      .then(response => {
        if (this.lAction === 'create') {
          response.data.forEach(rec => {
            this.lEmpDetails.push({
              emp_doc_type_id: rec.emp_doc_type_id,
              emp_doc_type: rec.emp_doc_type,
              vendor_id: rec.vendor_id,
              files: []
            })
          })
        } else {
          response.data.forEach(rec => {
            this.lEmpDetails.push({
              emp_doc_type_id: rec.emp_doc_type_id,
              emp_doc_type: rec.emp_doc_type,
              vendor_id: rec.vendor_id,
              file_url: rec.file_url,
              files: []
            })
          })
          var path = require('path')
          var files = ''
          this.lEmpDetails.forEach(rec => {
            files = ''
            if (rec.file_url) {
              files = rec.file_url.split(',')
              if (files.length > 0) {
                files.forEach(file => {
                  rec.files.push({
                    file_url: file,
                    file_name: file ? path.basename(file) : '',
                    is_selected: true,
                    is_changes: false
                  })
                })
              }
            }
          })
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err)
      })
    },
    loadMasterDocTypes () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.empDocTypes = []
      this.axios.get(config.API_URL + '/getDocumentTypeBasedonVendorId/', qry)
      .then(response => {
        this.empDocTypes = response.data
      })
      .catch(err => {
        this.msg(err)
      })
    },
    prepareEditEmp (curEmp) {
      // console.log(curEmp)
      this.lEmp = Object.assign({}, curEmp)
      this.lEmpDetails = []
      this.lEmp.changed_emp_id = this.lEmp.vendor_emp_id
      this.lEmp.emp_desig_pair = {emp_desig_id: this.lEmp.emp_desig_id, emp_desig: this.lEmp.emp_desig}
      this.lEmp.date_of_birth = this.lEmp.date_of_birth ? handy.formatDBDate(this.lEmp.date_of_birth) : null
      this.lEmp.date_of_joining = this.lEmp.date_of_joining ? handy.formatDBDate(this.lEmp.date_of_joining) : null
      this.lEmp.last_working_date = this.lEmp.last_working_date ? handy.formatDBDate(this.lEmp.last_working_date) : null
      this.lEmp.id_verified_date = this.lEmp.id_verified_date ? handy.formatDBDate(this.lEmp.id_verified_date) : null
      this.lEmp.address_verified_date = this.lEmp.address_verified_date ? handy.formatDBDate(this.lEmp.address_verified_date) : null
      this.lEmp.police_verif_date = this.lEmp.police_verif_date ? handy.formatDBDate(this.lEmp.police_verif_date) : null
      this.lEmp.uan = this.lEmp.uan ? this.lEmp.uan : ''
      this.lEmp.official_number = this.lEmp.official_number ? this.lEmp.official_number : ''
      this.lEmp.updated_user = config.SV_USER_ID
      this.empType = this.lEmp.is_sub_vendor_emp ? 'subvendor' : 'oe'
      this.isDupEmp = false
      this.dupOverride = false
      this.previousData = Object.assign({}, this.lEmp) // if there are any changes while updating at that time this will use to make Employee detail notes
      this.lAction = 'update'
      this.loadDesignation()
      this.loadSubVendor()
      this.loadDocType(curEmp.emp_id)
      this.loadEmpFamilyDetails(curEmp.emp_id)
    },
    saveEmployee (action) {
      // validate and save Changes
      if (!this.$refs.eForm.validate()) {
        return
      }
      if (this.lEmp.official_number && this.lEmp.official_number.length < 10) {
        this.msg('Official number should be of 10 number', 0)
        return
      }
      // preparation
      this.lEmp.emp_desig_id = this.lEmp.emp_desig_pair.emp_desig_id
      this.lEmp.emp_desig = this.lEmp.emp_desig_pair.emp_desig
      this.lEmp.is_sub_vendor_emp = this.empType === 'subvendor'
      // remove prefix and suffix space
      this.lEmp.emp_name = this.lEmp.emp_name ? this.lEmp.emp_name.trim() : ''
      // this.lEmp.years_exp = this.lEmp.years_exp.split(" ").join("") ? this.lEmp.years_exp.replace(/\s/g, '') : null
      this.lEmp.aadhar_no = this.lEmp.aadhar_no ? this.lEmp.aadhar_no.trim() : ''
      this.lEmp.official_number = this.lEmp.official_number ? this.lEmp.official_number.trim() : ''
      this.lEmp.emp_adr = this.lEmp.emp_adr ? this.lEmp.emp_adr.trim() : ''
      this.lEmp.city = this.lEmp.city ? this.lEmp.city.trim() : ''
      this.lEmp.pin_code = this.lEmp.pin_code ? this.lEmp.pin_code.trim() : ''
      this.lEmp.emp_phone = this.lEmp.emp_phone ? this.lEmp.emp_phone.trim() : '0'
      this.lEmp.emp_email = this.lEmp.emp_email ? this.lEmp.emp_email.trim() : ''
      this.lEmp.emergency_contact = this.lEmp.emergency_contact ? this.lEmp.emergency_contact.trim() : ''
      this.lEmp.emergency_phone = this.lEmp.emergency_phone ? this.lEmp.emergency_phone.trim() : ''
      this.lEmp.blood_group = this.lEmp.blood_group ? this.lEmp.blood_group.trim() : ''
      this.lEmp.known_health_issue = this.lEmp.known_health_issue ? this.lEmp.known_health_issue.trim() : ''
      this.lEmp.pan = this.lEmp.pan ? this.lEmp.pan.trim() : ''
      this.lEmp.pf_no = this.lEmp.pf_no ? this.lEmp.pf_no.trim() : ''
      this.lEmp.professional_fee = this.lEmp.professional_fee ? this.lEmp.professional_fee.trim() : ''
      this.lEmp.uan = this.lEmp.uan ? this.lEmp.uan.trim() : ''
      this.lEmp.esi_no = this.lEmp.esi_no ? this.lEmp.esi_no.trim() : ''
      this.lEmp.bank_acc_no = this.lEmp.bank_acc_no ? this.lEmp.bank_acc_no.trim() : ''
      this.lEmp.bank_ifsc_code = this.lEmp.bank_ifsc_code ? this.lEmp.bank_ifsc_code.trim() : ''
      this.lEmp.bank_name = this.lEmp.bank_name ? this.lEmp.bank_name.trim() : ''
      this.lEmp.bank_branch_name = this.lEmp.bank_branch_name ? this.lEmp.bank_branch_name.trim() : ''
      this.beingSaved = true

      this.lEmp.notes = ''
      if (action === 'update') {
        if (this.previousData.emp_name !== this.lEmp.emp_name) {
          this.lEmp.notes += ' Employee Name from "' + this.previousData.emp_name + '" to "' + this.lEmp.emp_name + '",'
        }
        if (this.previousData.emp_desig_pair.emp_desig_id !== this.lEmp.emp_desig_pair.emp_desig_id) {
          this.lEmp.notes += ' Designation from "' + this.previousData.emp_desig_pair.emp_desig + '" to "' + this.lEmp.emp_desig_pair.emp_desig + '",'
        }
        if (this.previousData.gender !== this.lEmp.gender) {
          this.lEmp.notes += ' Gender from "' + this.previousData.gender + '" to "' + this.lEmp.gender + '",'
        }
        if (this.previousData.date_of_joining !== this.lEmp.date_of_joining) {
          this.lEmp.notes += ' Date of Joining from "' + this.previousData.date_of_joining + '" to "' + this.lEmp.date_of_joining + '",'
        }
        if (this.previousData.years_exp !== this.lEmp.years_exp) {
          this.lEmp.notes += ' Years of Experience from "' + this.previousData.years_exp + '" to "' + this.lEmp.years_exp + '",'
        }
        if (this.previousData.date_of_birth !== this.lEmp.date_of_birth) {
          this.lEmp.notes += ' Date of Birth from "' + this.previousData.date_of_birth + '" to "' + this.lEmp.date_of_birth + '",'
        }
        if (this.previousData.aadhar_no !== this.lEmp.aadhar_no) {
          this.lEmp.notes += ' Aadhar no from "' + this.previousData.aadhar_no + '" to "' + this.lEmp.aadhar_no + '",'
        }
        if (this.previousData.marital_status !== this.lEmp.marital_status) {
          this.lEmp.notes += ' Marital Status from "' + this.previousData.marital_status + '" to "' + this.lEmp.marital_status + '",'
        }
        if (this.previousData.official_number !== this.lEmp.official_number) {
          this.lEmp.notes += ' Official no from "' + this.previousData.official_number + '" to "' + this.lEmp.official_number + '",'
        }
        if (this.previousData.emp_status !== this.lEmp.emp_status) {
          this.lEmp.notes += ' Employee Status from "' + this.previousData.emp_status + '" to "' + this.lEmp.emp_status + '",'
        }
        if (this.previousData.status_reason !== this.lEmp.status_reason) {
          this.lEmp.notes += ' Relieving Reason from "' + this.previousData.status_reason + '" to "' + this.lEmp.status_reason + '",'
        }
        if (this.previousData.last_working_date !== this.lEmp.last_working_date) {
          this.lEmp.notes += ' Last Working Date from "' + this.previousData.last_working_date + '" to "' + this.lEmp.last_working_date + '",'
        }
        if (this.previousData.emp_adr !== this.lEmp.emp_adr) {
          this.lEmp.notes += ' Address from "' + this.previousData.emp_adr + '" to "' + this.lEmp.emp_adr + '",'
        }
        if (this.previousData.city !== this.lEmp.city) {
          this.lEmp.notes += ' City from "' + this.previousData.city + '" to "' + this.lEmp.city + '",'
        }
        if (this.previousData.pin_code !== this.lEmp.pin_code) {
          this.lEmp.notes += ' PIN Code from "' + this.previousData.pin_code + '" to "' + this.lEmp.pin_code + '",'
        }
        if (this.previousData.emp_phone !== this.lEmp.emp_phone) {
          this.lEmp.notes += ' Phone no from "' + this.previousData.emp_phone + '" to "' + this.lEmp.emp_phone + '",'
        }
        if (this.previousData.emp_email !== this.lEmp.emp_email) {
          this.lEmp.notes += ' Email from "' + this.previousData.emp_email + '" to "' + this.lEmp.emp_email + '",'
        }
        if (this.previousData.emergency_contact !== this.lEmp.emergency_contact) {
          this.lEmp.notes += ' Emergency Contact Person from "' + this.previousData.emergency_contact + '" to "' + this.lEmp.emergency_contact + '",'
        }
        if (this.previousData.emergency_phone !== this.lEmp.emergency_phone) {
          this.lEmp.notes += ' Emergency Phone from "' + this.previousData.emergency_phone + '" to "' + this.lEmp.emergency_phone + '",'
        }
        if (this.previousData.blood_group !== this.lEmp.blood_group) {
          this.lEmp.notes += ' Blood Group from "' + this.previousData.blood_group + '" to "' + this.lEmp.blood_group + '",'
        }
        if (this.previousData.known_health_issue !== this.lEmp.known_health_issue) {
          this.lEmp.notes += ' Health Issus Known from "' + this.previousData.known_health_issue + '" to "' + this.lEmp.known_health_issue + '",'
        }
        if (this.previousData.payroll_cat !== this.lEmp.payroll_cat) {
          this.lEmp.notes += ' Payroll Category from "' + this.previousData.payroll_cat + '" to "' + this.lEmp.payroll_cat + '",'
        }
        if (this.previousData.is_pan_available !== this.lEmp.is_pan_available) {
          this.lEmp.notes += ' Is PAN Opted? from "' + this.previousData.is_pan_available + '" to "' + this.lEmp.is_pan_available + '",'
        }
        if (this.previousData.pan !== this.lEmp.pan) {
          this.lEmp.notes += ' PAN from "' + this.previousData.pan + '" to "' + this.lEmp.pan + '",'
        }
        if (this.previousData.is_pf_opted !== this.lEmp.is_pf_opted) {
          this.lEmp.notes += ' Is PF Opted? from "' + this.previousData.is_pf_opted + '" to "' + this.lEmp.is_pf_opted + '",'
        }
        if (this.previousData.pf_no !== this.lEmp.pf_no) {
          this.lEmp.notes += ' PF No from "' + this.previousData.pf_no + '" to "' + this.lEmp.pf_no + '",'
        }
        if (this.previousData.uan !== this.lEmp.uan) {
          this.lEmp.notes += ' UAN from "' + this.previousData.uan + '" to "' + this.lEmp.uan + '",'
        }
        if (this.previousData.is_esi_opted !== this.lEmp.is_esi_opted) {
          this.lEmp.notes += ' Is ESI Opted? from "' + this.previousData.is_esi_opted + '" to "' + this.lEmp.is_esi_opted + '",'
        }
        if (this.previousData.esi_no !== this.lEmp.esi_no) {
          this.lEmp.notes += ' ESI No from "' + this.previousData.esi_no + '" to "' + this.lEmp.esi_no + '",'
        }
        if (this.previousData.bank_acc_no !== this.lEmp.bank_acc_no) {
          this.lEmp.notes += ' Bank Account No from "' + this.previousData.bank_acc_no + '" to "' + this.lEmp.bank_acc_no + '",'
        }
        if (this.previousData.bank_ifsc_code !== this.lEmp.bank_ifsc_code) {
          this.lEmp.notes += ' Bank IFSC Code No from "' + this.previousData.bank_ifsc_code + '" to "' + this.lEmp.bank_ifsc_code + '",'
        }
        if (this.previousData.bank_name !== this.lEmp.bank_name) {
          this.lEmp.notes += ' Bank Name from "' + this.previousData.bank_name + '" to "' + this.lEmp.bank_name + '",'
        }
        if (this.previousData.bank_branch_name !== this.lEmp.bank_branch_name) {
          this.lEmp.notes += ' Bank Branch Name from "' + this.previousData.bank_branch_name + '" to "' + this.lEmp.bank_branch_name + '",'
        }
      }
      this.lEmp.action_by = config.SV_USER_ID

      // check for closely matching existing employees to avoid duplication
      var qry = {
        params: {
        }
      }
      qry.params = Object.assign({},this.lEmp)
      qry.params.vendor_id = config.VENDOR_ID
      this.beingSaved = true
      this.axios.get(config.API_URL + '/searchDupEmployee/', qry)
      .then(response => {
        if (response.data.length && !this.dupOverride) {
          if (action === 'create') {
            this.isDupEmp = true
            this.dupEmpList = response.data
          } else {
            // exclude employee being edited from duplicate check
            this.dupEmpList = response.data.filter(rec => rec.emp_id !== this.lEmp.emp_id)
            this.isDupEmp = this.dupEmpList.length > 0
          }
          this.dupOverride = false
        } else {
          this.isDupEmp = false
        }
        if (!this.isDupEmp) {
          this.lEmp.details = this.lEmpDetails
          this.axios.post(config.API_URL + '/employee/' + action, this.lEmp)
          .then(response => {
            // commit the changes in front end as well
            if (action === 'update') {
              let idx = this.empList.findIndex(rec => rec.emp_id === this.lEmp.emp_id)
              Object.assign(this.empList[idx], this.lEmp)
            } else {
              this.lEmp.emp_id = response.data[0]
            }

            this.msg('Saved successfully', 1)
            this.lAction = 'view'
            this.beingSaved = false
          })
          .catch(err => {
            this.msg(err.response.data)
            this.beingSaved = false
          })
        } else {
          this.beingSaved = false
        }
      })
    },
    cancelChanges () {
      this.beingSaved = false
      this.lAction = 'view'
    },
    deleteEmp () {
      if (!confirm('Sure, you want to delete the Employee with name "' + this.lEmp.emp_name + '"?')) {
        return
      }
      // delete employee
      this.axios.post(config.API_URL + '/employee/delete', this.lEmp)
      .then(response => {
        // commit the changes in front end as well
        let idx = this.empList.findIndex(rec => rec.emp_id === this.lEmp.emp_id)
        this.empList.splice(idx, 1)
        this.msg('Deleted successfully', 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    clear () {
      this.$refs.sForm.reset()
      this.empList.length = []
      this.showAllColumns = false
    },
    pickFile (curId) {
      this.empDocTypeId = curId
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser () {
      var idx = this.lEmpDetails.findIndex(rec => rec.emp_doc_type_id === this.empDocTypeId)
      const files = event.target.files
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            this.lEmpDetails[idx].files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    showDocTypeList () {
      this.loadDocType()
      this.lDAction = 'view'
      this.showDocType = true
    },
    prepareCreateDocType () {
      this.lDocType = {
        emp_doc_type: '',
        vendor_id: config.VENDOR_ID
      }
      this.lDAction = 'create'
      this.showInsertUpdateDocType = true
    },
    prepareUpdateDocType (curDocType) {
      this.lDocType = Object.assign({}, curDocType)
      this.lDAction = 'update'
      this.showInsertUpdateDocType = true
    },
    saveDocTypeChange (action) {
      if (action === 'delete-doctype') {
        if (!confirm('Sure, you want to delete the Doc Type with name "' + this.lDocType.emp_doc_type + '"?')) {
          return
        }
      }
      this.axios.post(config.API_URL + '/employee/' + action, this.lDocType)
      .then(response => {
        // commit the changes in front end as well
        this.loadDocType()
        this.showInsertUpdateDocType = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    addEmpFamilyDet (curEmpId) {
      this.lEmpFamilyDetails = {
        emp_id: curEmpId,
        family_name: '',
        relation_with_emp: '',
        dob: null,
        residing_with_him: false,
        contact_number: null,
        nominee: false,
        action: 'Create'
      }
      this.showEmpFamilyDetList = true
    },
    saveEmpFamilydetail (action) {
      // validate and save Changes
      if (!this.$refs.cForm.validate()) {
        return
      }
      if (action === 'delete') {
        if (!confirm('Sure, you want to delete the Family Details with Family name "' + this.lEmpFamilyDetails.family_name + '"?')) {
          return
        }
      }
      this.axios.post(config.API_URL + '/employeeFamilyDetails/' + action, this.lEmpFamilyDetails)
      .then(response => {
        // commit the changes in front end as well
        this.loadEmpFamilyDetails(this.lEmpFamilyDetails.emp_id)
        if (action === 'delete') {
          this.msg('Deleted successfully', 1)
        } else {
          this.msg('Saved successfully', 1)
        }
        this.lEmpFamilyDetails.action = 'view'
        this.showEmpFamilyDetList = false
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
      })
    },
    loadEmpFamilyDetails (curEmpId) {
      var qry = {
        params: {
          emp_id: curEmpId
        }
      }
      this.EmpFamilyDetailsList = []
      this.axios.get(config.API_URL + '/getEmpFamilyDetailsByEmpId/', qry)
      .then(response => {
        this.EmpFamilyDetailsList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdateFamilyDet (curRec) {
      this.lEmpFamilyDetails = Object.assign({}, curRec)
      this.lEmpFamilyDetails.dob = handy.formatDBDate(curRec.dob)
      this.lEmpFamilyDetails.action = 'Update'
      this.showEmpFamilyDetList = true
    },
    promptUpload () {
      this.$refs.ipFile.click()
    },
    prepareEmpTimeline () {
      var qry = {
        params: {
          emp_id: this.lEmp.emp_id
        }
      }
      this.axios.get(config.API_URL + '/getEmpDetailsAsTimeline/', qry)
      .then(response => {
        this.lEmpTimeline = response.data
        var timeLineNote = []
        timeLineNote = response.data.filter(rec => rec.notes !== null)
        if (timeLineNote) {
          var note = ''
          var cidx = 0
          for (var k = 0; k < timeLineNote.length; k++) {
            cidx = response.data.findIndex(rec => rec.emp_det_id === timeLineNote[k].emp_det_id)
            note = timeLineNote[k].notes.split(',')
            this.lEmpTimeline[cidx].timeLineNote = []
            for (var i = 0; i < note.length; i++) {
              this.lEmpTimeline[cidx].timeLineNote[i] = note[i]
            }
          }
        }
        this.showTimeline = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpload () {
      this.lAction = 'upload'
    },
    validateFile () {
      this.lAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0
      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqHeaders.length; i++) {
          if (headers[i] !== this.reqHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < this.colNames.length; c++) {
              if (this.colNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += this.reqHeaders[c] + ' is empty; '
              } else {
                res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
              }
              if (res['asset_value'] === '') {
                res['asset_value'] = null
              }
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    async uploadEmployee () {
      // create asset List one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''
      var tmpDt = null
      for (var i = 0; i < this.recsLoaded.length; i++) {
        curRec = this.recsLoaded[i]
        if (!this.recsLoaded[i].error) { // process only valid records
          // fill-in gaps
          if (!curRec.pf_no) {
            curRec.pf_no = null
          }
          if (!curRec.uan) {
            curRec.uan = null
          }
          if (!curRec.esi_no) {
            curRec.esi_no = null
          }
          if (!curRec.gmc_no) {
            curRec.gmc_no = null
          }
          if (!curRec.gpa_no) {
            curRec.gpa_no = null
          }
          if (!curRec.bank_acc_no) {
            curRec.bank_acc_no = null
          }
          if (!curRec.bank_ifsc_code) {
            curRec.bank_ifsc_code = null
          }
          // create record
          curRec.action_by = config.SV_USER_ID
          await this.axios.post(config.API_URL + '/bulkuploadofEmployee/', this.recsLoaded[i])
          .then(response => {
            curRec.load_status = 'Loaded'
            this.totLoaded++
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
          })
        }
      } // for every record
      if (!this.totFail) {
        this.msg('Uploaded successfully', 1)
        this.lAction = 'view'
      }
      this.loadInProgress = false
      this.beingSaved = false
    },
    showError (err) {
      this.msg(err, 0)
    },
    approveUsWebEmp () {
      // Update FM Created employee status
      this.axios.post(config.API_URL + '/employee/approve', this.lEmp)
      .then(response => {
        this.msg('Approved successfully', 1)
        this.lAction = 'view'
        this.beingSaved = false
        this.searchEmployee()
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    calculateAge (dofb) {
      console.log(dofb)
      if (!dofb) return
      const currentDate = new Date()
      if (new Date(dofb) > currentDate) {
        this.birthDate = null
        this.years = null
        this.months = null
        this.days = null
        alert('Invalid Date of Birth')
      }
      const diffTime = currentDate - new Date(dofb)
      const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
      this.years = Math.floor(totalDays / 365.25)
      this.months = Math.floor((totalDays % 365.25) / 30.4375)
      this.days = Math.floor((totalDays % 365.25) % 30.4375)
      // this.lEmp.years_exp = this.years + ' Years, ' + this.months + ' Months, ' + this.days + ' Days'
      this.lEmp.years_exp = this.years
    }
  }
}
</script>

<style lang="scss">
.my-label-text-size .v-label {
  font-size: 14px !important;
}
</style>
